import { createRouter, createWebHistory } from "vue-router";

const routes = [
	{
		path: "/home",
		name: "home",
		component: () => import("../views/HomeView.vue"),
	},
	{
		path: "/test2023001",
		name: "HomeViewtest",
		component: () => import("../views/HomeViewtest.vue"),
	},
	{
		path: "/pay",
		name: "pay",
		component: () => import("../views/Pay.vue"),
	},
	{
		path: "/payCancel",
		name: "payCancel",
		component: () => import("../views/PayCancel.vue"),
	},
	{
		path: "/order",
		name: "order",
		component: () => import("../views/order.vue"),
	},
	{
		path: "/remittance",
		name: "remittance",
		component: () => import("../views/Remittance.vue"),
	},
	{
		path: "/domestic",
		name: "domestic",
		component: () => import("../views/Domestic.vue"),
	},
	{
		path: "/remittanceUpdate",
		name: "remittanceUpdate",
		component: () => import("../views/RemittanceUpdate.vue"),
	},
	{
		path: "/domesticUpdate",
		name: "domesticUpdate",
		component: () => import("../views/DomesticUpdate.vue"),
	},
	{
		path: "/admin",
		name: "admin",
		component: () => import("../views/admin.vue"),
	},
	{
		path: "/upgrade",
		name: "upgrade",
		component: () => import("../views/Upgrade.vue"),
	},
	{
		path: "/:pathMatch(.*)",
		redirect: "/upgrade",
	},
];

const router = createRouter({
	history: createWebHistory(import.meta.env.VITE_APP_BASE_URL),
	routes,
});

router.beforeEach((to, from) => {
	window.document.documentElement.setAttribute("data-route", to.name);
	return true;
});

export default router;
